(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
let tabs = document.querySelectorAll('.section--product-tabs .tabs__tab');
if (tabs) {
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      console.log(tab.dataset.collectionUrl);
      let seeAllBtn = tab.closest('.section--product-tabs').querySelector('.section__btn .btn');

      if (seeAllBtn) {
        seeAllBtn.setAttribute('href', tab.dataset.collectionUrl);
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
